<template>
  <div class="newVow">
    <div class="newVowBg"></div>
    <div class="new-content">
      <div class="new-header"></div>
      <div class="new-title flex-row">
        <span class="new-title-dot"></span>
        <span>点击选择您想发出的祝福</span>
      </div>
      <div
        v-for="(item,index) in allWish"
        :key="index"
        @click="select_wish(index)"
        :class="'new-wish-item'+(sel_wish_index==index?' new-wish-item-active':'')"
      >{{item}}</div>
      <div class="new-title flex-row">
        <span class="new-title-dot"></span>
        <span>没有合适的？自己写一句吧</span>
      </div>
      <input
        type="text"
        v-model="xy"
        @blur="scrollTop(1)"
        class="new-input"
        placeholder="输入您的祝福..."
        maxlength="30"
      />
      <div class="new-pos flex-row">
        <input type="checkbox" name="pos" id="checkbox01" v-model="ischeck"  v-on:change="changePos"/>
        <label class="flex-row" for="checkbox01">
          <div class="new-pos-input flex-row">
            <span v-show="ischeck" class="selected"></span>
          </div>&nbsp;显示我的祈福位置
        </label>
        <!-- <div>显示我的祈福位置</div> -->
      </div>
      <div class="new-mypos-wrap flex-row" v-show="ischeck">
        <span>我在</span>
        <input
          type="text"
          v-model="mypos"
          class="new-input mypos"
          @blur="scrollTop(2)"
          placeholder="请填写您的位置"
          maxlength="20"
        />
        <span>祈福</span>
      </div>
      <div class="new-mypos-empty flex-row" v-show="!ischeck"></div>
      <!-- <div class="new-wish-warning">用户自定义的祈福内容，无忧行不承担相关的法律责任</div> -->
      <div
        class="new-wish-btn"
        :class="{'disabled': xy.length==0 && sel_wish_index<0 }"
        @click="goWish"
      >确定</div>
      <div class="new-warning-wrap text-center">
        <div @click="disclaimer">免责声明</div>
        <div v-show="isclaim" class="new-wish-warning">由用户自定义的祈福内容，无忧行不承担相关的法律责任</div>
      </div>
    </div>
    <!-- 已许愿弹窗 -->
    <div v-if="iswish" class="help-alert-wrap flex-column">
      <div class="help-alert fail flex-column">
        <div class="help-alert-title">许愿</div>
        <div class="help-alert-name">你已完成许愿</div>
        <div class="help-alert-desc02">只能许一次愿望哦</div>
        <div @click="godraw" class="common-bg help-alert-btn">返回首页</div>
      </div>
      <img @click="closeWish" class="alert-close" src="../../static/images/alert_close.png" alt />
    </div>
    <!-- 中奖啦弹窗 v-if="iswin==1 && myaward" -->
    <div v-if="iswin==1 && myaward" class="help-alert-wrap flex-column">
      <div class="help-alert flex-column">
        <div class="help-alert-title">中奖啦</div>
        <div class="help-alert-desc">已放入您的账户，可前往【我的奖品】查看</div>
        <div class="help-alert-gift flex-row">
          <div class="help-alert-gift-left">
            <img class="help-alert-gift-default" src="../../static/images/gift_default.png" alt />
          </div>
          <div class="help-alert-gift-right flex-data">
            <!-- {{myaward.award_desc}} -->
            <p class="help-alert-gift-text">{{myaward.award_desc}}</p>
            <div class="help-alert-gift-time">有效期至{{activityInfo.end_time_format}}</div>
          </div>
        </div>
        <div class="new-alert-btn flex-row">
          <div @click="goposter" class="common-bg help-alert-btn help-alert-btn2">收集祝福</div>
          <template>
            <div
              v-if="_getBrowser() == 1"
              @click="useAward"
              class="common-bg help-alert-btn2 help-alert-btn"
            >去使用</div>
            <div
              v-else
              class="common-bg help-alert-btn help-alert-btn2 btn-clipboard"
              id="btnH5"
              @click="_downloadAPP(1,'homepage2#pop_getsuccess_appdownload')"
              data-clipboard-target="#hello"
            >去APP使用</div>
            <input type="hidden" id="hello" value style="display:none;" />
          </template>
        </div>
        <div class="new-alert-warning">祝福越多越容易被实现哦</div>
      </div>
      <img @click="closeWin" class="alert-close" src="../../static/images/alert_close.png" alt />
    </div>
    <!-- 许愿确认弹窗 -->
    <div v-if="isSure" class="help-alert-wrap flex-column">
      <div class="help-alert fail flex-column">
        <div class="help-alert-title">提示</div>
        <div class="help-alert-name vowsText">
          心愿发布后，不可修改或删除，
          确定许愿吗？
        </div>
        <div class="vowBtnView">
          <div class="vowBtn">
            <p @click="closeVow" class="vowBtnText">再想想</p>
          </div>
          <div @click="goWish" class="vowBtn">
            <p class="vowBtnText">确定许愿</p>
          </div>
        </div>
      </div>
      <!-- <img
        class="alert-close"
        src="../../static/images/alert_close.png"
        alt
      />-->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Button, Swipe, SwipeItem, Lazyload, Picker, Toast, Field } from "vant";
// import btn from "../../static/images/vow_btn3.png";
// import btn2 from "../../static/images/vow_btn5.png";
Vue.use(Field);
export default {
  name: "NewVow",
  data() {
    return {
      xy: "",
      mypos: "",
      ischeck: false,
      isclaim:false,
      // btnImg: btn2,
      enableBtn: true, //禁用
      iswish: false,
      iswin: -1,
      sel_wish_index: -1,
      myaward: null,
      isSure: false,
      allWish: [
        "武汉加油！我们一起打赢这场仗!",
        "加油白衣天使！ 加油武汉！加油中国！",
        "Stay with you! Wuhan!",
        "武汉挺住，你不孤单！",
        "希望更多物资抵达一线！疫情尽快好起来！",
        "向逆行的战士敬礼！"
      ]
    };
  },
  methods: {

    // 显示隐藏声明
    disclaimer(){
      this.isclaim = !this.isclaim
    },
    changePos(){
      console.log('##ischeck:',this.ischeck)
      if(this.ischeck){
        this._deepmain(this.pageId, "显示我的祈福位置", 2)
      }
    },    

    //选择一条祝福
    select_wish(idx) {
      var t = this;
      this.sel_wish_index = idx;
      t.xy = t.allWish[idx];
      t._deepmain(t.pageId, "选择提供祈福语句", 2);
    },

    // 滚动到顶部
    scrollTop(idx) {
      window.scroll(0, 0);
      if(idx == 1){
        this._deepmain(this.pageId, "手动输入祈福语句", 2)
      }else{
        this._deepmain(this.pageId, "手动输入位置", 2)
      }
      
    },
    // btnEnable(e) {
    //   if (e.length > 0) {
    //     this.enableBtn = true;
    //     this.btnImg = btn;
    //   } else {
    //     this.enableBtn = false;
    //     this.btnImg = btn2;
    //   }
    // },
    goposter() {
      this.$router.push({
        path: "/shareindex",
        query: {
          iswin: 1,
          vowtext: encodeURIComponent(this.xy)
        }
      });
    },
    closeVow() {
      this.isSure = !this.isSure;
    },
    //去许愿
    goWish() {
      var t = this;
      t._deepmain(t.pageId, "确定祈福文案", 2)
      if (t.sel_wish_index < 0 && !t.xy) {
        t.$toast("请设置您的祝福");
        return;
      }
      if (t.ischeck && !t.mypos) {
        t.$toast("请输入您的位置");
        return;
      }
      var pray_str = t.xy;
      // if(!pray_str) pray_str = allWish[t.sel_wish_index];
      // if (t.xy) {
      t._deepmain(t.pageId, "sharepg#submitwish", 2);
      var params = {
        pray_str: pray_str,
        pray_address: t.mypos
      };
      t._get("user", "User.userPray", params)
        .then(res => {
          // t.closeVow();
          if (res.status == 0) {
            // t.iswin = 1;
            // t.myaward = res.data;
            t.$router.push({
              path: "/shareindex",
              query: {
                vowtext: encodeURIComponent(params.pray_str),
                place: t.ischeck == true ? t.mypos : ""
              }
            });
          } else {
            // if(res.status == 50005)用户未绑定手机号
            // typeof callback == "function" && callback(error);
            // if (res.status == 50008) {
            //   t.iswish = true;
            //   return false;
            // }
            t.$toast(res.msg);
            t.$router.push({
              path: "/shareindex",
              query: {
                vowtext: encodeURIComponent(params.pray_str),
                place: t.ischeck == true ? t.mypos : ""
              }
            });
          }
        })
        .catch(error => {
          // typeof callback == "function" && callback(error);
          console.log(`error:${error}`);
          t.$toast("请求错误");
        });
      // } else {
      //   t.$toast("请输入您的愿望");
      // }
    },

    //立即使用
    useAward() {
      var t = this;
      t.$router.push({
        path: "/team",
        query: {}
      });
    },
    closeWin() {
      this.iswin = -1;
      // this.isCountUpper = false;
      this.godraw();
    },
    // 去抽奖页
    godraw() {
      this.$router.push({
        path: "/vowdraw",
        query: {}
      });
    },
    closeWish() {
      this.iswish = !this.iswish;
    }
  }
};
</script>
<style scoped lang="scss" src="../../static/scss/helpme.scss"></style>
<style scoped lang="scss" src="../../static/scss/newvow.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>
